<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Arial; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">Dedication</h1>
<p>I would like to dedicate my work to everybody I have loved and lost in my life, it made me the person I am today. Special thanks to my true friends that have supported me when times have been tough and have kept me sane and motivated. I hope you know who you are!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4a6f393a